import { useQueries } from '@tanstack/react-query'

import { getDraftPaymentRequestEvidenceFile } from '@src/api'
import { DefaultApiGetDraftPaymentRequestEvidenceFileRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchDraftPaymentRequestEvidenceFiles = (
  params: DefaultApiGetDraftPaymentRequestEvidenceFileRequest[]
) => {
  const { axiosInstance } = useAxios()
  axiosInstance.defaults.responseType = 'arraybuffer'

  return useQueries({
    queries: params.map((param) => {
      return {
        enabled: !!params.length,
        queryFn: () => getDraftPaymentRequestEvidenceFile(axiosInstance, param),
        queryKey: [
          REACT_QUERY_CACHE_KEYS.GET_PAYMENT_REQUEST_DRAFT_EVIDENCE_FILE,
          param.organizationId,
          param.draftPaymentRequestId,
          param.evidenceId,
        ],
      }
    }),
    combine: (results) => {
      return {
        data: results.map((result) => result.data),
        isSuccess: results.every((result) => result.isSuccess),
      }
    },
  })
}
